import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "form-list-wrapper" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-head pb-3\"><h1 class=\"card-title\">Manage Project Tags</h1></div><div class=\"row align-items-center\"><div class=\"col-6\"><h1 class=\"title mb-0\">Project Tags</h1></div></div>", 2)
const _hoisted_5 = {
  class: "table-responsive my-3",
  id: "filteredGuestUsers"
}
const _hoisted_6 = { class: "table table-shadowed mb-0 table-bordered" }
const _hoisted_7 = /*#__PURE__*/_createVNode("thead", { class: "table-primary text-nowrap" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Tag Name"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Status"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Created Date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Created By"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "badge badge-success" }, "Enable", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "badge badge-danger" }, "Disable", -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "table-button" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-stop-circle" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Enable")
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-stop-circle" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Disable ")
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { colspan: 5 }, [
    /*#__PURE__*/_createVNode("p", { class: "text-danger text-center" }, [
      /*#__PURE__*/_createVNode("strong", null, "No Tags Found !!!")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_5, [
            _createVNode("table", _hoisted_6, [
              _hoisted_7,
              (_ctx.state.data.projectTagList && _ctx.state.data.projectTagList.length)
                ? (_openBlock(), _createBlock("tbody", _hoisted_8, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectTagList, (tag, formIndex) => {
                      return (_openBlock(), _createBlock("tr", { key: formIndex }, [
                        _createVNode("td", null, [
                          (tag.name)
                            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                                _createVNode("h5", null, _toDisplayString(tag.name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("td", null, [
                          (tag.is_active && tag.is_active === 1)
                            ? (_openBlock(), _createBlock("p", _hoisted_10, [
                                _hoisted_11
                              ]))
                            : (_openBlock(), _createBlock("p", _hoisted_12, [
                                _hoisted_13
                              ]))
                        ]),
                        _createVNode("td", null, [
                          _createVNode("p", null, _toDisplayString(tag.created), 1)
                        ]),
                        _createVNode("td", null, [
                          (tag.user)
                            ? (_openBlock(), _createBlock("p", _hoisted_14, _toDisplayString(tag.user.full_name), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_15, "-"))
                        ]),
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_16, [
                            (tag.is_active  != 1)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "javascript:void(0)",
                                  class: "btn enable-btn mr-1",
                                  onClick: ($event: any) => (_ctx.enableTag(tag))
                                }, [
                                  _hoisted_17,
                                  _hoisted_18
                                ], 8, ["onClick"]))
                              : (_openBlock(), _createBlock("a", {
                                  key: 1,
                                  href: "javascript:void(0)",
                                  class: "btn delete-btn mr-1",
                                  onClick: ($event: any) => (_ctx.enableTag(tag))
                                }, [
                                  _hoisted_19,
                                  _hoisted_20
                                ], 8, ["onClick"]))
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock("tfoot", _hoisted_21, [
                    _hoisted_22
                  ]))
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}